// extracted by mini-css-extract-plugin
module.exports = {"series-collections__container":"SeriesCollections_series-collections__container__XGtXC","series-collections__title":"SeriesCollections_series-collections__title__m1oDF"};